<template>
  <v-row>
    <v-col cols="12" lg="8" md="12">
      <v-card>
        <v-toolbar dense color="red lighten-1">
          <v-toolbar-title class="white--text">Escalas</v-toolbar-title>
        </v-toolbar>
        <v-data-table :headers="headers" :items="scales" multi-sort :search="search">
          <template v-slot:top>
            <v-row class="d-flex">
              <v-col cols="6" sm="6">
                <v-text-field v-model="search" label="Pesquisar" class="mx-4"></v-text-field>
              </v-col>
              <v-col cols="6" sm="6">
                <v-select
                  :items="departments"
                  item-value="department"
                  item-text="department"
                  label="Setor"
                  @change="filterDepartment"
                ></v-select>
              </v-col>
            </v-row>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn icon link large text :key="item.id" @click="downloadPdf(item.id)">
              <v-icon large color="blue">mdi-cloud-download</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  name: 'ScaleList',
  data: function () {
    return {
      search: '',
      headers: [
        { text: 'Mês', align: 'start', value: 'month_name' },
        { text: 'Ano', value: 'year' },
        { text: 'Setor', value: 'department' },
        { text: 'Status', value: 'status_name' },
        { text: 'Ações', value: 'actions', sortable: false },
      ],
      // departments_list: [
      //   {
      //     text: 'department',
      //     value: 'department',
      //     header: departments,
      //   },
      // ],
    }
  },
  methods: {
    ...mapActions('employees', ['ActionDownloadScalePDF']),
    async downloadPdf(scale_id) {
      await this.ActionDownloadScalePDF(scale_id)
    },
    filterList(value, search, item) {
      search = search.toUpperCase()
      value != null ? (value = value.toString()) : (value = null)

      return (
        value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLocaleUpperCase().indexOf(search) !== -1
      )
    },
    filterDepartment(department) {
      this.search = department
    },
  },
  computed: {
    ...mapGetters('utils', ['GET_departmentById']),
    ...mapState('employees', ['scales']),
    ...mapState('utils', ['departments']),
  },
  components: {
    // ScaleFormCreate
  },
}
</script>
